<button
    [id]="id()"
    [attr.data-testid]="id()"
    [attr.data-uiType]="'button'"
    (click)="reset()"
    [attr.data-styleTarget]="id()"
    [attr.data-styleDisabled]="disabled()"
    class="rounded-full py-2 px-4 bg-transparent font-button uppercase active:bg-dat-grey-050 text-dat-blue-500"
>
    <span
        [attr.data-testid]="id() + '-label'"
        [attr.data-uiType]="'label'"
        [attr.data-styleTarget]="id()"
        class="iq-md"
        [datiqTemplateMd]="label()"
    ></span>
</button>
